import { Button, Icon, Modal, Typography } from "@/components/atoms";
import { Vehicle } from "@/redux/slices/vehicle/types";
import { clsx } from "@/utils";

interface VehicleTypesModalProps {
  vehicle: Vehicle | null;
  onClose: () => void;
}

export const VehicleTypesModal = ({ vehicle, onClose }: VehicleTypesModalProps) => {
  // Prefer the many-to-many set; fall back to the legacy single type.
  const types = vehicle?.vehicleTypes?.length ? vehicle.vehicleTypes : vehicle?.vehicleType ? [vehicle.vehicleType] : [];

  return (
    <Modal
      open={!!vehicle}
      onClose={onClose}
      title="Vehicle Types"
      description={vehicle ? `${vehicle.model.make} ${vehicle.model.model} • ${vehicle.registrationNumber}` : ""}
      variant="web-small"
      renderButtons={() => (
        <Button variant="tertiary" size="md" onClick={onClose}>
          Close
        </Button>
      )}
    >
      <div className="flex flex-col">
        {types.map((type, index) => (
          <div key={type.uuid} className={clsx("flex items-center gap-3 py-3", index > 0 && "border-t border-neutral-gray")}>
            <Icon name="Car" variant="Bold" size="sm" className="text-neutral-dark-gray" />
            <Typography variant="paragraph">{type.name}</Typography>
          </div>
        ))}
      </div>
    </Modal>
  );
};
